import {
    Link,
    PageIntro,
    PageIntroDescription,
    PageIntroHeader,
    PageIntroHeading,
    PageIntroSideIllustration,
    PageIntroSplitMain,
    Skeleton,
    TextSkeleton,
} from '@gitbook/spine-react';

import { createDocumentationURL } from '../../../utils';
import imageDark from '../assets/integrations-intro-dark.raw.svg';
import imageLight from '../assets/integrations-intro-light.raw.svg';
import { IntegrationSearchInput } from './IntegrationSearchInput';

/**
 * Page intro for the integrations screen.
 */
export function IntegrationsPageIntro() {
    return (
        <PageIntro kind="centered">
            <PageIntroHeading>Integrations</PageIntroHeading>
            <PageIntroDescription>
                Enhance your GitBook experience by integrating with your favorite apps and{' '}
                <Link
                    href={createDocumentationURL('integrations/integrations', 'developer')}
                    rel="none"
                    target="_blank"
                >
                    your custom integrations
                </Link>
                .
            </PageIntroDescription>
            <IntegrationSearchInput />
        </PageIntro>
    );
}

/** Skeleton for the integrations screen page intro. */
export function IntegrationsPageIntroSkeleton() {
    return (
        <PageIntro kind="centered">
            <TextSkeleton className="text-ui-page-title">Integrations</TextSkeleton>
            <div>
                <TextSkeleton>
                    Enhance your GitBook experience by integrating with your
                </TextSkeleton>
                <TextSkeleton>favorite apps and your custom integrations.</TextSkeleton>
            </div>
            <Skeleton
                shape="rect"
                className="mt-4 min-h-8 min-w-52 px-3 py-2 max-md:w-full md:flex-1"
            />
        </PageIntro>
    );
}

/** Will be deleted after new integrations screen is released. */
export function LegacyIntegrationsPageIntro() {
    return (
        <PageIntro>
            <PageIntroSplitMain>
                <PageIntroHeader>
                    <PageIntroHeading>Integrations</PageIntroHeading>
                </PageIntroHeader>
                <PageIntroDescription>
                    <p>Extend functionality by integrating with your favorite tools. </p>
                    <p>
                        Can't find the integration you need, or want to integrate GitBook with your
                        own product?{' '}
                        <Link
                            href={createDocumentationURL('integrations/integrations', 'developer')}
                            rel="none"
                            target="_blank"
                        >
                            Build your own integrations
                        </Link>
                        .
                    </p>
                </PageIntroDescription>
            </PageIntroSplitMain>
            <PageIntroSideIllustration
                src={{ dark: imageDark, light: imageLight }}
                width={470}
                height={150}
            />
        </PageIntro>
    );
}
